import React from 'react';
const Badge = ({ children, variant = 'default', size = 'md', className = '', dot = false }) => {
    const variantStyles = {
        default: 'bg-gray-100 text-gray-800',
        primary: 'bg-orange-100 text-orange-800',
        success: 'bg-green-100 text-green-800',
        warning: 'bg-yellow-100 text-yellow-800',
        danger: 'bg-red-100 text-red-800',
        info: 'bg-blue-100 text-blue-800'
    };
    const sizeStyles = {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-2.5 py-0.5 text-xs'
    };
    const dotColors = {
        default: 'text-gray-600',
        primary: 'text-orange-600',
        success: 'text-green-600',
        warning: 'text-yellow-600',
        danger: 'text-red-600',
        info: 'text-blue-600'
    };
    return React.createElement("span", { className: `inline-flex items-center font-medium rounded-full ${sizeStyles[size]} ${variantStyles[variant]} ${className}` },
        dot && React.createElement("svg", { className: `mr-1.5 h-2 w-2 ${dotColors[variant]}`, fill: "currentColor", viewBox: "0 0 8 8" },
            React.createElement("circle", { cx: "4", cy: "4", r: "3" })),
        children);
};
export default Badge;
